import { render, staticRenderFns } from "./fieldCollection.vue?vue&type=template&id=2d00febc&scoped=true&"
import script from "./fieldCollection.vue?vue&type=script&lang=js&"
export * from "./fieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./fieldCollection.vue?vue&type=style&index=0&id=2d00febc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00febc",
  null
  
)

export default component.exports